import { render, staticRenderFns } from "./PurchaseReturnList.vue?vue&type=template&id=2dec9524&"
import script from "./PurchaseReturnList.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseReturnList.vue"
export default component.exports